<template>
  <div class="reg_box">
    <img src="../assets/img/logo.png" alt="" />
    <div class="login_box">
      <h2>修改密码</h2>
      <el-form
        label-position="top"
        :model="ruleForm"
        :rules="rules"
        ref="ruleFormref"
        class="demo-ruleForm form"
      >
        <el-form-item prop="email" label="电子邮箱">
          <el-input v-model="ruleForm.email" placeholder="电子邮箱"> </el-input>
        </el-form-item>
        <el-form-item prop="code" label="邮箱验证">
          <template>
            <div class="emi_num">
              <el-input v-model="ruleForm.code" placeholder="邮箱验证码">
              </el-input>
              <el-button class="emi_num_btn" @click="subEmai"
                >邮箱获取验证码</el-button
              >
            </div></template
          >
        </el-form-item>

        <el-form-item prop="password" label="新密码">
          <el-input type="password" v-model="ruleForm.password" placeholder="新密码">
          </el-input>
        </el-form-item>

        <el-form-item>
          <div class="login_fot">
            <el-button @click="$router.push('/login')" class="first">
              返回
            </el-button>
            <el-button @click="sbumit" class="sbmit">确认</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="login_ftr  login_ftrp">
      <p>Copyright (c) 2020   京ICP备15005281号-1 All Rights Reserved</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    // const validatePass2 = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请输入密码'))
    //   } else if (value != this.ruleForm.password) {
    //     console.log(this.ruleForm.password)
    //     callback(new Error('两次密码不一致，请重新输入'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      ruleForm: {
        email: '',
        code: '',

        password: ''
      },
      rules: {
        email: [{ required: true, message: '请输入电子邮箱', trigger: 'blur' }],
        code: [
          { required: true, message: '请输入邮箱验证码', trigger: 'blur' }
        ],

        password: [{ required: true, message: '请输入新密码', trigger: 'blur' }]
      }
    }
  },
  components: {},
  methods: {
    async sbumit() {
      this.$refs.ruleFormref.validate(async valid => {
        if (valid) {
          let res = await this.$api.Home.eidtPwd(this.ruleForm)
          if (res.code == 0) {
            this.$message.success(res.msg)
            this.$router.push('/login')
          } else {
            this.$message.error(res.msg)
          }
        } else {
          return false
        }
      })
    },
    async subEmai() {
      if (this.ruleForm.email !== '') {
        let res = await this.$api.Home.senEei({ email: this.ruleForm.email })
        if (res.code == 0) {
          this.$message.success("修改密码成功！")
        }
      } else {
        this.$message.warning('请输入电子邮箱')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.reg_box {
  width: 100%;
  height: 1080px;
  background: url('../assets/img/bg2.png') no-repeat center;
  background-size: 100% 100%;
  .login_ftrp {
    padding-bottom: 122px;
    box-sizing: border-box;
    color: #73b0db !important;
  }
  .login_fot {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    .first {
      background-color: #ffffff;
    }
    .sbmit {
      color: #ffffff;
    }
    button {
      width: 120px;
      height: 50px;
      background-color: #00599e;
      border-radius: 5px;
      border: solid 1px #eeeeee;
      font-family: 'SourceHanSansCN-Regular';
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #666666;
      cursor: pointer;
    }
  }
  img {
    width: 132px;
    height: 130px;
    display: block;
    margin: 0 auto;
    padding-top: 139px;
  }
  h2 {
    height: 34px;
    font-family: SourceHanSansCN-Regular;
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #00599e;

    text-align: center;
  }
  .login_box {
    padding: 59px 60px 58px 61px;
    box-sizing: border-box;
    width: 600px;
    height: 600px;
    background-color: #ffffff;
    border-radius: 27px;
    margin: 40px auto 0;
    .emi_num {
      display: flex;
      justify-content: space-between;
      /deep/.el-input {
        margin-right: 10px;
      }
      .emi_num_btn {
        width: 200px;
        height: 50px;
        background-color: #e73917;
        border-radius: 5px;
        border: 0;
        font-family: SourceHanSansCN-Regular;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
      }
    }
  }
}
/deep/.el-form-item__label {
  padding: 0 !important;
}
/deep/.el-form-item {
  margin-bottom: 10px !important;
}
/deep/.el-input__inner {
  height: 50px !important;
}
</style>
